import VehicleTaskForm from './VehicleTaskForm';

/** IAD — Secure vehicles (settlement) */
export default function Frame44() {
  return <VehicleTaskForm taskKind="secure" />;
}
